export enum RelationProductType {
  COORDI = 'COORDI',
  TOGETHER = 'TOGETHER',
  VMD = 'VMD',
}

export enum RelationProductStatusType {
  NORMAL = 'NORMAL',
  DELETE = 'DELETE',
}

export enum RelationProductDisplayStatusType {
  ON = 'ON',
  SUSPENSION = 'SUSPENSION',
  BLOCK = 'BLOCK',
}

export enum ChannelServiceType {
  STOREFARM = 'STOREFARM',
  WINDOW = 'WINDOW',
}
